import type {AddServiceFunctionFormPayload} from "./add-service-function.schema";

import {addServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function addServiceFunctionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.addServiceFunction,
    mutationFn: (payload: AddServiceFunctionFormPayload) => addServiceFunction(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
